import { CUSTOMER_JOURNEY_WEATHER } from './../const';

function action(token, lang, context) {
  return { type: CUSTOMER_JOURNEY_WEATHER, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyWeather.js